import { useCallback, useEffect, useState } from 'preact/hooks';

// This hooks checks if their children is overflowing
const useOverflow = (
  elementRef: React.RefObject<HTMLElement | null>,
): [boolean] => {
  const [isOverflow, setOverflow] = useState<boolean>(false);

  const checkOverflow = useCallback(() => {
    if (!elementRef?.current) {
      setOverflow(false);
      return;
    }

    const { offsetWidth, scrollWidth } = elementRef.current;
    setOverflow(offsetWidth < scrollWidth);
  }, [elementRef]);

  useEffect(() => {
    checkOverflow();

    window.addEventListener('resize', checkOverflow);

    return () => {
      window.addEventListener('resize', checkOverflow);
    };
  }, [checkOverflow]);

  return [isOverflow];
};

export default useOverflow;
